import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { cn } from "@/shared/lib/utils";
import styles from "./IconChip.module.scss";
export const IconChip = React.forwardRef(({ icon, selected = false, className, children, type = "button", ...rest }, ref) => {
    return (_jsxs("button", { ref: ref, type: type, "aria-pressed": selected, className: cn(styles.chip, selected && styles.selected, className), ...rest, children: [icon && _jsx("span", { className: styles.icon, children: icon }), _jsx("span", { children: children })] }));
});
IconChip.displayName = "IconChip";
